module.exports = __webpack_public_path__ + "img/IMG_1867_L_BlackMatted_MockedUp.f4ec310a.jpg";